import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  disabled = false,
  loading = false,
  className = '',
  ...props 
}) => {
  const baseClasses =
    'font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed ' +
    'dark:focus:ring-offset-gray-900';
  
  const variants = {
    primary:
      'bg-primary-500 hover:bg-primary-600 text-white focus:ring-primary-500 ' +
      'dark:bg-primary-600 dark:hover:bg-primary-500 dark:focus:ring-primary-400',
    secondary:
      'bg-gray-200 hover:bg-gray-300 text-gray-800 focus:ring-gray-500 ' +
      'dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-100 dark:focus:ring-gray-400',
    danger:
      'bg-red-500 hover:bg-red-600 text-white focus:ring-red-500 ' +
      'dark:bg-red-600 dark:hover:bg-red-500 dark:focus:ring-red-400',
    outline:
      'border border-gray-300 hover:bg-gray-50 text-gray-700 focus:ring-primary-500 ' +
      'dark:border-gray-600 dark:hover:bg-gray-800 dark:text-gray-200 dark:focus:ring-primary-400'
  };
  
  const sizes = {
    small: 'px-3 py-1.5 text-sm',
    medium: 'px-4 py-2 text-sm',
    large: 'px-6 py-3 text-base'
  };

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;

  return (
    <button className={classes} disabled={disabled || loading} {...props}>
      {loading ? (
        <span className="flex items-center">
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Loading...
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
